export default __webpack_public_path__ + "static/media/main_banner.5d2a6963.png";